import { PERIODS } from 'shared/config';

export const createTerm = (termDuration: number | null | undefined, termPeriod: string): string => {
  if (termDuration === null || termDuration === undefined) {
    throw new Error('termDuration cannot be null or undefined');
  }
  return `P${termDuration}${termPeriod}`;
};

/**
 * Разделяет строку периода на числовую длительность и строковое обозначение периода.
 *
 * @param period - Строка периода в формате ISO 8601 (например, "P12M" для 12 месяцев).
 * @returns Кортеж, где первый элемент - числовая длительность, второй элемент - строковое обозначение периода.
 *
 * @example:
 * splitTermToPeriodAndDuration("P12M") // [12, "M"]
 * splitTermToPeriodAndDuration() // [0, "M"]
 */
export const splitTermToPeriodAndDuration = (period?: string): [number, string] => {
  if (!period) {
    return [0, PERIODS.MONTH];
  }
  const termDuration = parseInt(period.match(/\d+/)?.[0] ?? '1', 10);
  const termPeriod = period.match(/[A-Z]+$/)?.[0] || PERIODS.MONTH;

  return [termDuration, termPeriod];
};
